import * as React from 'react';
import Modal from 'react-modal';

class ConfirmModal extends React.Component<{func: (open) => void}, { open: boolean }> {
    constructor(){
        super();
        this.state = {
            open: false,
        }
    }
    show = () => this.setState({ open: true });
    onClose = () => {
      this.setState({ open: false });
      this.props.func(false);
    }

    onOK = () => {
      this.setState({ open: false });
      this.props.func(true);
    }

    render(){
        return(
            <Modal isOpen={this.state.open} ariaHideApp={false}
                className='react-bs-insert-modal modal-dialog' 
                contentLabel='Modal'>
                <div className="modal-content react-bs-table-insert-modal">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.onClose} ><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title">Запрашиваемая сумма</h4>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={this.onOK}>ОК</button>
                        <button type="button" className="btn btn-default btn-secondary" onClick={this.onClose}>Отмена</button>
                    </div>
                </div>
            </Modal>
        );
    }
}
export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/components/request/ConfirmModal.tsx